import useSignUpWithCredentials from './useSignUpWithCredentials'
export default useSignUpWithCredentials
